import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/authContext';
import { useIsMobile } from '../hooks/useIsMobile';
export const Landing = () => {
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    const isMobile = useIsMobile();
    React.useEffect(() => {
        if (isAuthenticated) {
            navigate('/my-jobs', { replace: true });
        }
    }, [isAuthenticated, navigate]);
    const handleLogin = () => {
        navigate('/login');
    };
    const handleContactClick = () => {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    };
    return (_jsxs("div", { style: styles.page, children: [_jsx("header", { style: styles.header, children: _jsxs("div", { style: styles.headerContent, children: [_jsxs("div", { style: styles.logo, children: [_jsx("h1", { style: styles.logoText, children: "Glazier" }), _jsx("p", { style: styles.logoSubtext, children: "Premium Glass Solutions" })] }), _jsx("button", { onClick: handleLogin, style: styles.loginButton, children: "Login" })] }) }), _jsx("section", { style: {
                    ...styles.hero,
                    padding: isMobile ? '60px 20px' : '140px 20px',
                }, children: _jsxs("div", { style: styles.heroContent, children: [_jsx("h2", { style: {
                                ...styles.heroTitle,
                                fontSize: 'clamp(32px, 7vw, 64px)',
                            }, children: "Expert Glass Repair & Installation" }), _jsx("p", { style: {
                                ...styles.heroSubtitle,
                                fontSize: 'clamp(16px, 3.5vw, 24px)',
                            }, children: "Professional glass repair and custom shower door installation for your home" }), _jsx("button", { onClick: handleContactClick, style: styles.ctaButton, children: "Get a Free Quote" })] }) }), _jsx("section", { style: {
                    ...styles.servicesSection,
                    padding: isMobile ? '60px 20px' : '100px 20px',
                }, children: _jsxs("div", { style: styles.container, children: [_jsx("h2", { style: styles.sectionTitle, children: "Our Services" }), _jsxs("div", { style: styles.servicesGrid, children: [_jsxs("div", { style: styles.serviceCard, children: [_jsx("img", { src: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500&h=300&fit=crop", alt: "Glass Repair", style: styles.serviceImage }), _jsx("h3", { style: styles.serviceTitle, children: "Glass Repair" }), _jsx("p", { style: styles.serviceDescription, children: "Professional repair of broken windows, glass doors, and glass panels. Quick response times and quality workmanship." }), _jsxs("ul", { style: styles.serviceList, children: [_jsx("li", { children: "Window pane replacement" }), _jsx("li", { children: "Tempered glass repair" }), _jsx("li", { children: "Glass door repair" }), _jsx("li", { children: "Same-day service available" })] })] }), _jsxs("div", { style: styles.serviceCard, children: [_jsx("img", { src: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=500&h=300&fit=crop", alt: "Shower Glass Doors", style: styles.serviceImage }), _jsx("h3", { style: styles.serviceTitle, children: "Shower Glass Doors" }), _jsx("p", { style: styles.serviceDescription, children: "Custom-designed and installed shower glass doors that enhance your bathroom with style and elegance." }), _jsxs("ul", { style: styles.serviceList, children: [_jsx("li", { children: "Frameless designs" }), _jsx("li", { children: "Semi-frameless options" }), _jsx("li", { children: "Custom sizing & shapes" }), _jsx("li", { children: "Professional installation" })] })] }), _jsxs("div", { style: styles.serviceCard, children: [_jsx("img", { src: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=500&h=300&fit=crop", alt: "Installation & Maintenance", style: styles.serviceImage }), _jsx("h3", { style: styles.serviceTitle, children: "Installation & Maintenance" }), _jsx("p", { style: styles.serviceDescription, children: "Expert installation of new glass fixtures and ongoing maintenance to keep your glass looking pristine." }), _jsxs("ul", { style: styles.serviceList, children: [_jsx("li", { children: "Professional installation" }), _jsx("li", { children: "Weatherproofing & sealing" }), _jsx("li", { children: "Regular maintenance plans" }), _jsx("li", { children: "Warranty coverage" })] })] })] })] }) }), _jsx("section", { style: {
                    ...styles.whyUsSection,
                    padding: isMobile ? '60px 20px' : '100px 20px',
                }, children: _jsxs("div", { style: styles.container, children: [_jsx("h2", { style: styles.sectionTitle, children: "Why Choose Glazier?" }), _jsxs("div", { style: styles.benefitsGrid, children: [_jsxs("div", { style: styles.benefit, children: [_jsx("div", { style: styles.benefitIconBox, children: _jsx("svg", { style: styles.benefitSvg, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: _jsx("polyline", { points: "20 6 9 17 4 12" }) }) }), _jsx("h3", { style: styles.benefitTitle, children: "20+ Years Experience" }), _jsx("p", { style: styles.benefitText, children: "Trusted by thousands of homeowners across the region" })] }), _jsxs("div", { style: styles.benefit, children: [_jsx("div", { style: styles.benefitIconBox, children: _jsx("svg", { style: styles.benefitSvg, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: _jsx("path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" }) }) }), _jsx("h3", { style: styles.benefitTitle, children: "Licensed & Insured" }), _jsx("p", { style: styles.benefitText, children: "Full insurance coverage and certified technicians" })] }), _jsxs("div", { style: styles.benefit, children: [_jsx("div", { style: styles.benefitIconBox, children: _jsxs("svg", { style: styles.benefitSvg, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [_jsx("path", { d: "M9 11l3 3L22 4" }), _jsx("path", { d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z" })] }) }), _jsx("h3", { style: styles.benefitTitle, children: "Guaranteed Quality" }), _jsx("p", { style: styles.benefitText, children: "5-year warranty on all installations and repairs" })] }), _jsxs("div", { style: styles.benefit, children: [_jsx("div", { style: styles.benefitIconBox, children: _jsxs("svg", { style: styles.benefitSvg, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [_jsx("circle", { cx: "12", cy: "12", r: "1" }), _jsx("path", { d: "M12 6v6m0 0v6" })] }) }), _jsx("h3", { style: styles.benefitTitle, children: "Fast Response" }), _jsx("p", { style: styles.benefitText, children: "Emergency repairs available 24/7" })] })] })] }) }), _jsx("section", { style: {
                    ...styles.testimonialSection,
                    padding: isMobile ? '60px 20px' : '100px 20px',
                }, children: _jsxs("div", { style: styles.container, children: [_jsx("h2", { style: styles.sectionTitle, children: "What Our Customers Say" }), _jsxs("div", { style: styles.testimonialsGrid, children: [_jsxs("div", { style: styles.testimonialCard, children: [_jsx("div", { style: styles.starsContainer, children: [...Array(5)].map((_, i) => (_jsx("svg", { style: styles.star, viewBox: "0 0 24 24", fill: "currentColor", children: _jsx("path", { d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z" }) }, i))) }), _jsx("p", { style: styles.testimonialText, children: "\"Glazier replaced our shower door and it looks amazing! Professional service and great pricing. Highly recommended!\"" }), _jsx("p", { style: styles.testimonialAuthor, children: "Sarah M." })] }), _jsxs("div", { style: styles.testimonialCard, children: [_jsx("div", { style: styles.starsContainer, children: [...Array(5)].map((_, i) => (_jsx("svg", { style: styles.star, viewBox: "0 0 24 24", fill: "currentColor", children: _jsx("path", { d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z" }) }, i))) }), _jsx("p", { style: styles.testimonialText, children: "\"Emergency window repair on a Sunday? No problem. They came out the same day and fixed it perfectly.\"" }), _jsx("p", { style: styles.testimonialAuthor, children: "James K." })] }), _jsxs("div", { style: styles.testimonialCard, children: [_jsx("div", { style: styles.starsContainer, children: [...Array(5)].map((_, i) => (_jsx("svg", { style: styles.star, viewBox: "0 0 24 24", fill: "currentColor", children: _jsx("path", { d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z" }) }, i))) }), _jsx("p", { style: styles.testimonialText, children: "\"The custom glass work on our home is beautiful. Every detail was perfect. Worth every penny!\"" }), _jsx("p", { style: styles.testimonialAuthor, children: "Lisa T." })] })] })] }) }), _jsx("section", { style: {
                    ...styles.contactSection,
                    padding: isMobile ? '60px 20px' : '100px 20px',
                }, children: _jsxs("div", { style: styles.container, children: [_jsx("h2", { style: styles.sectionTitle, children: "Get Your Free Quote Today" }), _jsxs("div", { style: styles.contactContent, children: [_jsx("p", { style: styles.contactText, children: "Contact us for a free consultation and estimate. Our team is ready to help!" }), _jsxs("div", { style: styles.contactInfo, children: [_jsxs("div", { style: styles.contactMethod, children: [_jsx("div", { style: styles.contactIconBox, children: _jsx("svg", { style: styles.contactSvg, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: _jsx("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" }) }) }), _jsx("p", { style: styles.contactLabel, children: "(555) 123-4567" })] }), _jsxs("div", { style: styles.contactMethod, children: [_jsx("div", { style: styles.contactIconBox, children: _jsxs("svg", { style: styles.contactSvg, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [_jsx("rect", { x: "2", y: "4", width: "20", height: "16", rx: "2" }), _jsx("path", { d: "m22 7-10 5L2 7" })] }) }), _jsx("p", { style: styles.contactLabel, children: "quote@glazier.com" })] }), _jsxs("div", { style: styles.contactMethod, children: [_jsx("div", { style: styles.contactIconBox, children: _jsxs("svg", { style: styles.contactSvg, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [_jsx("circle", { cx: "12", cy: "12", r: "10" }), _jsx("polyline", { points: "12 6 12 12 16 14" })] }) }), _jsxs("p", { style: styles.contactLabel, children: ["Mon-Fri: 8AM - 6PM", _jsx("br", {}), "Sat: 9AM - 4PM"] })] })] }), _jsx("button", { onClick: handleLogin, style: styles.ctaButtonLarge, children: "Schedule a Consultation" })] })] }) }), _jsx("footer", { style: styles.footer, children: _jsx("div", { style: styles.container, children: _jsx("p", { children: "\u00A9 2026 Glazier. All rights reserved. Licensed & Insured." }) }) })] }));
};
const styles = {
    page: {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        color: '#1d1d1f',
        background: 'linear-gradient(to bottom, #f5f5f7 0%, #ffffff 50%)',
    },
    header: {
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        position: 'sticky',
        top: 0,
        zIndex: 100,
    },
    headerContent: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '16px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    logo: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    logoText: {
        fontSize: '28px',
        fontWeight: '700',
        margin: 0,
        background: 'linear-gradient(135deg, #0071e3 0%, #54b0fd 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
    },
    logoSubtext: {
        fontSize: '12px',
        margin: 0,
        color: '#86868b',
        fontWeight: '400',
    },
    loginButton: {
        padding: '8px 20px',
        backgroundColor: 'rgba(0, 113, 227, 0.1)',
        color: '#0071e3',
        border: '1px solid rgba(0, 113, 227, 0.2)',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
    },
    hero: {
        background: 'linear-gradient(135deg, #0071e3 0%, #0077ed 50%, #54b0fd 100%)',
        color: 'white',
        padding: '140px 20px',
        textAlign: 'center',
    },
    heroContent: {
        maxWidth: '800px',
        margin: '0 auto',
    },
    heroTitle: {
        fontSize: 'clamp(32px, 7vw, 64px)',
        fontWeight: '700',
        margin: '0 0 20px 0',
        letterSpacing: '-0.5px',
    },
    heroSubtitle: {
        fontSize: 'clamp(16px, 3.5vw, 24px)',
        margin: '0 0 40px 0',
        opacity: 0.92,
        fontWeight: '400',
        lineHeight: '1.4',
    },
    ctaButton: {
        padding: '14px 36px',
        backgroundColor: 'white',
        color: '#0071e3',
        border: 'none',
        borderRadius: '12px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
    },
    servicesSection: {
        padding: '100px 20px',
        backgroundColor: 'transparent',
    },
    container: {
        maxWidth: '1200px',
        margin: '0 auto',
    },
    sectionTitle: {
        fontSize: '48px',
        fontWeight: '700',
        margin: '0 0 60px 0',
        textAlign: 'center',
        letterSpacing: '-0.5px',
    },
    servicesGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
    },
    serviceCard: {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        padding: '40px',
        borderRadius: '20px',
        border: '1px solid rgba(255, 255, 255, 0.8)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
        transition: 'all 0.4s ease',
    },
    serviceImage: {
        width: '100%',
        height: '240px',
        objectFit: 'cover',
        borderRadius: '16px',
        marginBottom: '24px',
        display: 'block',
    },
    serviceTitle: {
        fontSize: '24px',
        fontWeight: '700',
        margin: '0 0 12px 0',
        color: '#1d1d1f',
    },
    serviceDescription: {
        fontSize: '16px',
        color: '#86868b',
        margin: '0 0 20px 0',
        lineHeight: '1.6',
        fontWeight: '400',
    },
    serviceList: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
    },
    whyUsSection: {
        padding: '100px 20px',
        backgroundColor: 'transparent',
    },
    benefitsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap: '40px',
    },
    benefit: {
        textAlign: 'center',
    },
    benefitIconBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '64px',
        height: '64px',
        margin: '0 auto 20px',
        backgroundColor: 'rgba(52, 199, 89, 0.1)',
        borderRadius: '16px',
    },
    benefitSvg: {
        width: '32px',
        height: '32px',
        color: '#34c759',
    },
    benefitTitle: {
        fontSize: '18px',
        fontWeight: '700',
        margin: '0 0 12px 0',
        color: '#1d1d1f',
    },
    benefitText: {
        fontSize: '15px',
        color: '#86868b',
        margin: 0,
        fontWeight: '400',
        lineHeight: '1.6',
    },
    benefitIcon: {
        display: 'none',
    },
    testimonialSection: {
        padding: '100px 20px',
        backgroundColor: 'transparent',
    },
    testimonialsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
        gap: '24px',
    },
    testimonialCard: {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        padding: '32px',
        borderRadius: '20px',
        border: '1px solid rgba(255, 255, 255, 0.8)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
    },
    starsContainer: {
        display: 'flex',
        gap: '4px',
        marginBottom: '16px',
    },
    star: {
        width: '16px',
        height: '16px',
        color: '#FFB81C',
    },
    testimonialText: {
        fontSize: '16px',
        lineHeight: '1.6',
        margin: '0 0 16px 0',
        fontStyle: 'italic',
        color: '#424245',
        fontWeight: '400',
    },
    testimonialAuthor: {
        fontSize: '14px',
        fontWeight: '600',
        margin: 0,
        color: '#1d1d1f',
    },
    contactSection: {
        padding: '100px 20px',
        backgroundColor: 'transparent',
    },
    contactContent: {
        maxWidth: '600px',
        margin: '0 auto',
        textAlign: 'center',
    },
    contactText: {
        fontSize: '18px',
        margin: '0 0 50px 0',
        color: '#86868b',
        fontWeight: '400',
        lineHeight: '1.6',
    },
    contactInfo: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '40px',
        margin: '0 0 50px 0',
    },
    contactMethod: {
        padding: '20px',
    },
    contactIconBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '56px',
        height: '56px',
        margin: '0 auto 16px',
        backgroundColor: 'rgba(0, 113, 227, 0.1)',
        borderRadius: '12px',
    },
    contactSvg: {
        width: '28px',
        height: '28px',
        color: '#0071e3',
    },
    contactLabel: {
        margin: 0,
        fontSize: '15px',
        fontWeight: '500',
        color: '#1d1d1f',
        lineHeight: '1.4',
    },
    ctaButtonLarge: {
        padding: '16px 44px',
        backgroundColor: '#0071e3',
        color: 'white',
        border: 'none',
        borderRadius: '12px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 10px 30px rgba(0, 113, 227, 0.3)',
    },
    footer: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        color: 'white',
        padding: '40px 20px',
        textAlign: 'center',
        marginTop: '40px',
    },
};
//# sourceMappingURL=Landing.js.map